/* Product-card image reliability, two layers:
   1. PRELOAD — slide-2+ images sit in hidden/0-height slides so native lazy
      loading never fetches them; the first swipe shows the cream card
      background while the image downloads. Flip them to eager once the card
      nears the viewport so they're cached before the user swipes.
   2. SELF-HEAL — the theme keeps card images invisible until the img's inline
      onload fires (animate_transition_image → opacity:0, skeleton-image →
      z-index:-1). Safari/WKWebView (Instagram in-app browser) drops load
      events on bfcache back-navigation and AJAX re-renders, leaving loaded
      images permanently hidden: the "cream card" bug. Re-apply the onload
      effects ourselves whenever an image is actually complete. */
(function () {
  'use strict';

  function reveal(img) {
    img.classList.remove('animate-Xpulse', 'skeleton-image');
    img.classList.add('active'); /* animate_transition_image → opacity 1 */
    var card = img.closest('.animate_transition_card__image');
    if (card) card.classList.add('lazy_active', 'active');
  }

  function heal(root) {
    var imgs = (root || document).querySelectorAll(
      'img.skeleton-image, img.animate-Xpulse, img.animate_transition_image:not(.active)'
    );
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        reveal(img);
      } else if (!img.dataset.tlHeal) {
        img.dataset.tlHeal = '1';
        img.addEventListener('load', function () { reveal(img); }, { once: true });
        /* On hard failure just drop the skeleton veil so we never trap the card. */
        img.addEventListener('error', function () {
          img.classList.remove('animate-Xpulse', 'skeleton-image');
        }, { once: true });
      }
    });
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        entry.target.querySelectorAll('.media-slide img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
        heal(entry.target);
      });
    }, { rootMargin: '300px' });
  }

  var observe = function () {
    if (!io) return;
    document.querySelectorAll('[id^="x-slideshow-card-product"]').forEach(function (el) {
      if (el.dataset.tlSlidePreload) return;
      el.dataset.tlSlidePreload = '1';
      io.observe(el);
    });
  };

  observe();
  heal(document);

  /* bfcache restore (back from a product page) is the main dropped-onload case. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) heal(document);
  });

  /* Collection filtering / cart upsell re-render cards via AJAX — re-observe and re-heal. */
  var debounce;
  new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      observe();
      heal(document);
    }, 300);
  }).observe(document.body, { childList: true, subtree: true });
})();
